module.exports = __webpack_public_path__ + "img/saving-pig.0869e65.svg";